<div id="content" class="allcp-form" ng-controller="WorkTypeController" >
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div class="row mt20">
		<div class="col-md-12">
			<div class="panel">
				<div class="panel-body pn">
					<form ng-submit="save()" class="form-horizontal allcp-form">
					
						<div class="form-group">
							<label class="col-md-3 control-label">
								KargoTipi Adı * 
							</label>
							<div class="col-md-9">
								<label for="name21" class="field prepend-icon">
									<input type="text" ng-model="workType.name" class="gui-input br-light light" placeholder="KargoTipi Adı" required>
									<label for="name21" class="field-icon">
										<i class="fa fa-list-alt"></i>
									</label>
								</label>
							</div>
						</div>
						
						<div class="form-group">
							<div class="col-md-12">
								<button type="submit" class="btn btn-primary pull-right"><span class="fa fa-save"></span> Kaydet</a>
							</div>
						</div>

					</form>
				</div>
			</div>
		</div>
	</div>
</div>